import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "absolute inset-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-0 bg-white/70 backdrop-blur-sm" }, null, -1)

import { onClickOutside, onKeyStroke } from '@vueuse/core';
import { toRefs } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    panel: null,
    close: null
  },
  setup(__props: any) {

const props = __props as {
  panel: HTMLElement,
  close:() => void,
}



const { panel, close } = toRefs(props);
onClickOutside(panel, close.value);
onKeyStroke('Escape', close.value);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})